module.exports = __webpack_public_path__ + "static/media/edit-blue-pencil.ec3395ea.svg";